// =================================================
// products.js
// =================================================

// =================================================
// Swiper
// =================================================
document.addEventListener('DOMContentLoaded', () => {
	const mainSwiper = new Swiper('.sec_box_pht_swiper', {
		// spaceBetween: 10,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 600,
	});

	const mainImgs = document.querySelectorAll('.sec_box_pht_swiper_list_item img');
	const thumbGrid = document.querySelector('.sec_box_pht_swiper_thumb_list');

	// サムネイル生成
	mainImgs.forEach((img, index) => {
		const thumb = document.createElement('img');
		thumb.src = img.src;
		thumb.alt = img.alt;
		thumb.dataset.index = index;
		thumbGrid.appendChild(thumb);

		thumb.addEventListener('click', () => {
			mainSwiper.slideTo(index);
			document.querySelectorAll('.sec_box_pht_swiper_thumb_list img').forEach(t => t.classList.remove('active'));
			thumb.classList.add('active');
		});
	});

	// 初期アクティブ設定
	thumbGrid.querySelector('img').classList.add('active');

	// メインが変わった時にサムネも同期
	mainSwiper.on('slideChange', () => {
		const idx = mainSwiper.activeIndex;
		document.querySelectorAll('.sec_box_pht_swiper_thumb_list img').forEach(t => t.classList.remove('active'));
		thumbGrid.querySelectorAll('img')[idx].classList.add('active');
	});
});

$(function() {
	// =================================================
	// tab
	// =================================================
	var mainId = $('main').attr('id');
	if (mainId) {
		$('#tab_' + mainId).addClass('active');
	}

	// =============================
	// Table transpose (800px以下で行列反転)
	// =============================
	let transposed = false; // 反転済みフラグ
	let originalHTML = null; // 元のHTML保存

	function transposeTable() {
		const table = document.querySelector('.match_box_table');
		if (!table) return;

		const rows = Array.from(table.rows);
		const rowCount = rows.length;
		const colCount = rows[0].cells.length;

		// 新しいテーブル作成
		const newTable = document.createElement('table');
		newTable.className = table.className;

		// 行列入れ替え
		for (let c = 0; c < colCount; c++) {
			const newRow = newTable.insertRow();
			for (let r = 0; r < rowCount; r++) {
				// th, tdを区別
				const oldCell = rows[r].cells[c];
				const newCell = (r === 0) ? document.createElement('th') : document.createElement('td');
				newCell.innerHTML = oldCell ? oldCell.innerHTML : '';
				newRow.appendChild(newCell);
			}
		}

		table.replaceWith(newTable);
		transposed = true;
	}

	function checkWidth() {
		const table = document.querySelector('.match_box_table');
		if (!table) return;

		if (window.innerWidth <= 800 && !transposed) {
			// 元の構造を保存
			originalHTML = table.outerHTML;
			transposeTable();
		} else if (window.innerWidth > 800 && transposed) {
			// 元の構造に戻す
			table.outerHTML = originalHTML;
			transposed = false;
		}
	}

	window.addEventListener('resize', checkWidth);
	window.addEventListener('load', checkWidth);
});


// =================================================
// Microsoft Clarity カスタムタグ
// 対象3商品ページで「カートに入れる」クリック時にタグを送信
// =================================================
(function() {
  var targetPages = [
    '/collections/all/products/opera',
    '/collections/all/products/delphi',
    '/collections/all/products/fez'
  ];

  var currentPath = window.location.pathname;
  var isTargetPage = targetPages.some(function(path) {
    return currentPath === path || currentPath.indexOf(path) === 0;
  });

  if (!isTargetPage) return;

  // フォームのsubmitイベントを監視
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('sec_box_desc_form')) return;

    if (typeof clarity === 'function') {
      e.preventDefault();
      clarity('set', '商品詳細_カートに入れる', currentPath);
      setTimeout(function() {
        form.submit();
      }, 0);
    }
  });
})();


// =================================================
// SPEC開閉：スマホ初回表示時のみ開く
// =================================================
(function() {

  // ページごとに別々のキーで管理
  var specKey = 'spec-closed-' + window.location.pathname;

  // すでにユーザーが閉じた場合は何もしない
  if (sessionStorage.getItem(specKey) === '1') return;

  // DOMContentLoaded後に実行
  document.addEventListener('DOMContentLoaded', function() {
    var toggleBtn    = document.querySelector('.sec_box_desc_spec_tit.js-toggle');
    var toggleTarget = document.querySelector('.sec_box_desc_spec_list.js-toggle-target');

    if (!toggleBtn || !toggleTarget) return;

    // 開いた状態にする
    toggleBtn.classList.add('is-active');
    $(toggleTarget).show();

    // ユーザーが閉じたらセッションストレージに記録（ページごと）
    toggleBtn.addEventListener('click', function() {
      sessionStorage.setItem(specKey, '1');
    });
  });
})();
